import { render, staticRenderFns } from "./copypressuremodal.vue?vue&type=template&id=77cdbb4d&"
import script from "./copypressuremodal.vue?vue&type=script&lang=ts&"
export * from "./copypressuremodal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "copypressuremodal.vue"
export default component.exports